<template>
    <section>
        <div id="menu" class="container">
            <div v-if="seleccion !== 'por kilo'">
                <h2 class="titulo" id="titulo">{{ seleccion }}</h2>
                <div class="slidecon">
                    <div class="contenedor__productos" id="cont__prod" @scroll="scrollOculto">
                        <div class="flex" id="flex">

                            <div v-if="this.$store.getters['product/data'].length == 0" class="productos__zanahoria">
                                <div>
                                    <picture>
                                        <source srcset="../assets/zanahoria_1.webp" type="image/webp">
                                        <img src="../assets/zanahoria_1.png" alt="zanahoria por kilo">
                                    </picture>
                                    <picture>
                                        <source srcset="../assets/zanahoria_2.webp" type="image/webp">
                                        <img src="../assets/zanahoria_2.png" alt="zanahoria por kilo">
                                    </picture>
                                    <picture>
                                        <source srcset="../assets/zanahoria_3.webp" type="image/webp">
                                        <img src="../assets/zanahoria_3.png" alt="zanahoria por kilo">
                                    </picture>
                                </div>
                            </div>

                            <div v-else class="productos" v-for="(categoria, index) in datacat" :key="index"
                                @scroll="contador(index)" @wheel="contador(index)">

                                <template v-for="(producto, k) in dataprod">
                                    <div v-if="categoria.name == producto.category_name" data-aos="fade-zoom-in"
                                        data-aos-easing="ease-in-back" data-aos-duration="500" class="opacidad only-pc">
                                        <div class="item">
                                            <img v-if="producto.image" :src="srcImg(producto.image)" alt="producto">
                                            <img v-else src="../assets/no_image.png" alt="no imagen">
                                            <div class="productos__info">
                                                <div class="superior">
                                                    <p>{{ producto.name }}</p>
                                                    <p v-if="producto.code.toString().length > 3">{{ producto.code }}</p>
                                                    <p
                                                        v-else-if="producto.code === null || producto.code === undefined || producto.code === ''">
                                                    </p>
                                                    <p v-else>{{ '0'.repeat(3 - producto.code.toString().length) +
                                                        producto.code.toString() }}</p>
                                                </div>

                                                <div class="inferior">
                                                    <h3 v-if="producto.range_prices.length > 1"> {{
                                                        "$" +
                                                        parseFloat(producto.range_prices[0]).toFixed(2) }} - {{ "$" +
                                                            parseFloat(producto.range_prices[producto.range_prices.length -
                                                                1]).toFixed(2) }}
                                                    </h3>
                                                    <h3 v-else class="producto-individual">
                                                        {{ "$" + parseFloat(producto.price).toFixed(2) }}
                                                    </h3>
                                                    <div>
                                                        <img src="../assets/sold.png" alt=""
                                                            :style="{ opacity: outOfStock(producto, dataStock[k].stock) }">
                                                        <div>
                                                            <a :href="`producto/${producto.url}`" @click="saveLS()">ver detalles</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="categoria.name == producto.category_name" data-aos="fade-zoom-in"
                                        data-aos-easing="ease-in-back" data-aos-duration="500"
                                        class="opacidad only-mov">
                                        <a :href="`producto/${producto.url}`">
                                            <div class="item">
                                                <img v-if="producto.image" :src="srcImg(producto.image)" alt="producto">
                                                <img v-else src="../assets/no_image.png" alt="no imagen">
                                                <div class="productos__info">
                                                    <div class="superior">
                                                        <p>{{ producto.name }}</p>
                                                        <p v-if="producto.code.toString().length > 3">{{ producto.code }}
                                                        </p>
                                                        <p
                                                            v-else-if="producto.code === null || producto.code === undefined || producto.code === ''">
                                                        </p>
                                                        <p v-else>{{ '0'.repeat(3 - producto.code.toString().length) +
                                                            producto.code.toString() }}</p>
                                                    </div>

                                                    <div class="inferior">
                                                        <h3 v-if="producto.range_prices.length > 1"> {{
                                                            "$" +
                                                            parseFloat(producto.range_prices[0]).toFixed(2) }} - {{ "$"
                                                                +
                                                                parseFloat(producto.range_prices[producto.range_prices.length
                                                                    -
                                                                    1]).toFixed(2) }}
                                                        </h3>
                                                        <h3 v-else class="producto-individual">
                                                            {{ "$" + parseFloat(producto.price).toFixed(2) }}
                                                        </h3>
                                                        <div>
                                                            <img src="../assets/sold.png" alt=""
                                                                :style="{ opacity: outOfStock(producto, dataStock[k].stock) }">
                                                            <div>
                                                                <a :href="`producto/${producto.url}`"
                                                                    @click="saveLS()">ver detalles</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="number"> {{ counter }}/{{ denominador }}</p>
            </div>
            <div v-else class="por__kilo" id="menu__busqueda">
                <h1>{{ seleccion }}</h1>
                <div class="contenedor__buscador">
                    <div v-if="dataFilter == 'Sin productos'" class="no-coincidencias">
                        <div v-if="this.$store.getters['product/data'].length == 0" class="animado">
                            <picture>
                                <source srcset="../assets/zanahoria_1.webp" type="image/webp">
                                <img src="../assets/zanahoria_1.png" alt="zanahoria por kilo">
                            </picture>
                            <picture>
                                <source srcset="../assets/zanahoria_2.webp" type="image/webp">
                                <img src="../assets/zanahoria_2.png" alt="zanahoria por kilo">
                            </picture>
                            <picture>
                                <source srcset="../assets/zanahoria_3.webp" type="image/webp">
                                <img src="../assets/zanahoria_3.png" alt="zanahoria por kilo">
                            </picture>
                        </div>
                        <div v-else>
                            <picture>
                                <source srcset="../assets/zanahoria_1.webp" type="image/webp">
                                <img src="../assets/zanahoria_1.png" alt="zanahoria por kilo">
                            </picture>
                            <picture>
                                <source srcset="../assets/zanahoria_2.webp" type="image/webp">
                                <img src="../assets/zanahoria_2.png" alt="zanahoria por kilo">
                            </picture>
                            <picture>
                                <source srcset="../assets/zanahoria_3.webp" type="image/webp">
                                <img src="../assets/zanahoria_3.png" alt="zanahoria por kilo">
                            </picture>
                            <h2>{{ buscando }}</h2>
                        </div>
                    </div>
                    <div v-else class="borde" v-for="(item, indice) in dataFilter" :key="indice" data-aos="fade-zoom-in"
                        data-aos-easing="ease-in-back" data-aos-duration="500">
                        <img class="borde__imagen" :src="srcImg(item.image)" alt="Producto PorKilo" v-if="item.image">
                        <img v-else src="../assets/no_image.png" alt="no imagen" class="borde__imagen">
                        <div>
                            <div class="arriba">
                                <p>{{ item.name }}</p>
                                <p v-if="item.id.toString()?.length > 3">{{ item.id }}</p>
                                <p v-else>{{ '0'.repeat(3 - item.id.toString()?.length) + item.id.toString() }}</p>
                            </div>
                            <div class="abajo">
                                <p v-if="item.range_prices.length > 1">
                                    {{ "$" + parseFloat(item.range_prices[0]).toFixed(2) }} - {{ "$" +
                                        parseFloat(item.range_prices[item.range_prices.length - 1]).toFixed(2) }}
                                </p>
                                <p v-else> {{ "$" + Number(item.price).toFixed(2) }}</p>
                                <a :href="`producto/${item.url}`" @click="saveLS()">ver detalles</a>
                            </div>
                        </div>
                        <img class="sold__out" src="../assets/sold.png" alt="Sold out"
                            v-if="dataFilterStock[indice].stock == 0">
                    </div>
                </div>
            </div>
            <div class="controles" v-if="seleccion != 'por kilo'">
                <img class="flecha" src="../assets/flecha.svg" alt="flecha izquierda"
                    @click="scrolling(lado[1], clases[0])">

                <div class="navegador" @scroll="handleScroll()">
                    <div v-for="(cat, index) in datacat" :key="index" @click="desliz(index); divisor(cat.name);"
                        tabindex="0">
                        <template v-if="cat.parent_name == 'MENU'">
                            <h2>{{ cat.name }}</h2>
                            <h3>{{ cat.name }}</h3>
                        </template>
                    </div>
                </div>

                <img class="flecha" src="../assets/flecha.svg" alt="flecha derecha"
                    @click="scrolling(lado[0], clases[0])">
            </div>
            <div v-else class="navegacion__buscador">
                <img class="flecha" src="../assets/flecha.svg" alt="flecha izquierda" @click="control(lado[1])">
                <div class="buscador__categorias" id="control__buscador">
                    <div v-for="(cat, index) in datacat.filter(objeto => objeto.parent_name === 'MENU')" :key="index"
                        class="categorias__texto" @click="retorno(index)">
                        <h2>{{ cat.name }}</h2>
                        <h3>{{ cat.name }}</h3>
                    </div>
                </div>
                <img class="flecha" src="../assets/flecha.svg" alt="flecha derecha" @click="control(lado[0])">
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from "vuex";
import AOS from 'aos';
import "aos/dist/aos.css"
let { url } = require("../global/index");
export default {
    name: "Store",
    data() {
        return {
            counter: 1,
            seleccion: "CHIPS",
            lado: ["derecha", "izquierda"],
            clases: ["navegador", "productos"],
            timer: null,
            denominador: 0,
            scrollLateral: 0,
            url: url,
            cargando: false,
            buscando: 'No se encontraron coincidencias...'
        }
    },
    components: {
    },

    async created() {
        await Promise.all([
            this.getAllInfoPrd("product"),
            this.getAllInfoCtg("category")
        ]);
    },

    mounted() {
        this.$parent.$on('etiqueta', this.retorno);
        AOS.init({
            once: true
        })
        if (this.added == "" || this.added == null) {
            if (typeof this.catAdded == "number") {
                setTimeout(() => {
                    this.desliz(this.catAdded)
                }, 4000);
                setTimeout(() => {
                    this.setAddedCts("");
                }, 4001);
            } else {
                this.seleccion = "CHIPS";
                this.divisor(this.seleccion)
            }
        } else {
            this.seleccion = "por kilo";
        }

    },


    computed: {
        dataprod() {
            let productoTotal;
            this.buscando = "Buscando productos..."
            try {
                productoTotal = this.$store.getters["product/data"]
            } catch (error) {
            }

            if (Array.isArray(productoTotal)) {
                productoTotal = productoTotal.filter(elemento => elemento.status != 'INACTIVO')
            }
            //.filter(elemento => elemento.status != 'INACTIVO')
            let nombresUnicos = {}; // Objeto auxiliar para rastrear nombres únicos
            let arregloFinal = [];

            for (let i = 0; i < productoTotal.length; i++) {
                if (!nombresUnicos[productoTotal[i].name]) {
                    nombresUnicos[productoTotal[i].name] = true; // Marcar el nombre como encontrado
                    arregloFinal.push(productoTotal[i]); // Agregar el producto único al arreglo final
                }
            }
            if (Array.isArray(productoTotal) && productoTotal.length == 0) {
                this.buscando = "No se encontraron coincidencias"
            }
            return arregloFinal
        },

        dataStock() {
            let productos = this.dataprod;
            let resultado = [];

            for (let k = 0; k < productos.length; k++) {
                let stock = productos[k].stock === 'Sin stock' ? 0 : parseInt(productos[k].stock);
                let encontrado = resultado.find(item => item.name === productos[k].name);

                if (encontrado) {
                    encontrado.stock += stock;
                } else {
                    resultado.push({ name: productos[k].name, stock: stock });
                }
            }
            return resultado
            // return productos
        },

        datacat() {
            let arr = this.$store.getters["category/data"];
            let narr = [];

            for (let i = 0; i < arr.length; i++) {
                if (arr[i].parent_name == "MENU") {
                    narr.push(arr[i])
                }
            }
            return narr
        },

        added() {
            return this.$store.getters["store/getAdded"]
        },

        catAdded() {
            return this.$store.getters["catstore/getAdded"]
        },

        dataFilter() {
            const arregloBusqueda = this.dataprod;
            let busqueda = this.soloNumeros(this.added) ? parseInt(this.added) : this.added?.toLowerCase();


            let nombresUnicos = {}; // Objeto auxiliar para rastrear nombres únicos
            let arregloFinal = [];


            if (busqueda != "") {

                for (let j = 0; j < arregloBusqueda.length; j++) {
                    const categoria = arregloBusqueda[j].category_name.toLowerCase();
                    const nombre = arregloBusqueda[j].name.toLowerCase();
                    const descripcion = arregloBusqueda[j].descr.toLowerCase();
                    const id = arregloBusqueda[j].id;

                    if (
                        categoria.includes(busqueda) ||
                        nombre.includes(busqueda) ||
                        descripcion.includes(busqueda) ||
                        id.toString().includes(busqueda)
                    ) {
                        if (!nombresUnicos[arregloBusqueda[j].name]) {
                            nombresUnicos[arregloBusqueda[j].name] = true; // Marcar el nombre como encontrado
                            arregloFinal.push(arregloBusqueda[j]); // Agregar el producto único al arreglo final
                        }
                    }

                }
                arregloFinal = arregloFinal

                if (Array.isArray(arregloFinal) && arregloFinal.length > 0) {

                    return arregloFinal
                } else {
                    this.buscando = "No se encontraron coincidencias";
                    return "Sin productos"
                }
            }
        },

        dataFilterStock() {
            const arregloBusqueda = this.dataprod;
            let busqueda = this.soloNumeros(this.added) ? parseInt(this.added) : this.added?.toLowerCase();
            let resultado = [];


            if (busqueda != "") {

                for (let l = 0; l < arregloBusqueda.length; l++) {
                    const categoria = arregloBusqueda[l].category_name.toLowerCase();
                    const nombre = arregloBusqueda[l].name.toLowerCase();
                    const descripcion = arregloBusqueda[l].descr.toLowerCase();
                    const id = arregloBusqueda[l].id;

                    if (
                        categoria.includes(busqueda) ||
                        nombre.includes(busqueda) ||
                        descripcion.includes(busqueda) ||
                        id.toString().includes(busqueda)
                    ) {
                        let stock = arregloBusqueda[l].stock === 'Sin stock' ? 0 : parseInt(arregloBusqueda[l].stock);
                        let encontrado = resultado.find(item => item.name === arregloBusqueda[l].name);

                        if (encontrado) {
                            encontrado.stock += stock;
                        } else {
                            resultado.push({ name: arregloBusqueda[l].name, stock: stock });
                        }
                    }
                }
                return resultado;
            }
        },

        calcularFilas() {
            const valor = Math.ceil(this.denominador / 2);
            return valor;
        }
    },

    watch: {
        added: {
            handler(newVal, oldVal) {
                this.$forceUpdate();
                const path = window.location.pathname
                this.seleccion = 'por kilo'
            },
            // immediate: true, // Esto activará el watcher inmediatamente después de que se cree el componente
        },
    },

    methods: {
        ...mapActions("product", ["getAllInfoPrd"]),
        ...mapActions("category", ["getAllInfoCtg"]),
        ...mapActions("product", ["searchPro"]),
        ...mapActions("carrito", ["setAddedCrt2"]),
        ...mapActions("store", ["setAddedStr"]),
        ...mapActions("catstore", ["getAddedCts"]),
        ...mapActions("catstore", ["setAddedCts"]),

        outOfStock(product, productStock) {
            
            if(Array.isArray(product.product_variantes) && product.product_variantes.length > 0) {
                const productos = product.product_variantes.find(producto => producto.stock !=0 && producto.producto.stock[0].stock != 0);
                if(productos) return 0;
                else return 1;
            }else {
                if (productStock == 0 || productStock == 'Sin stock') return 1;
                else return 0;
            }
        },

        srcImg(img) {
            let imagen = img.split(".")
            imagen[1] = 'webp'
            imagen = imagen.join('.')
            let src = `${url}/product-img/${imagen}`;
            return src
        },

        soloNumeros(entrada) {
            return /^[0-9]+$/.test(entrada);
        },

        scrollOculto() {
            const productos = document.querySelectorAll('.opacidad');

            productos.forEach(individual => {
                individual.style.opacity = "0";
            });
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.deslizOculto();
            }, 200);
        },

        deslizOculto() {
            const elemento = document.getElementById('cont__prod')
            let valor = Math.round(elemento.scrollLeft / elemento.offsetWidth)
            this.desliz(valor)
        },

        async retorno(indice) {
            try {
                await this.setAddedStr("");
                setTimeout(() => {
                    this.desliz(indice);
                }, 200);

            } catch (error) {
                console.error("Ocurrió un error en una de las acciones:", error);
            }
        },

        nombre() {
            if (this.seleccion !== "por kilo") {
                setTimeout(() => {
                    const texto = document.getElementById("titulo");
                    if (texto.innerHTML.length - 1 > 10) {
                        texto.classList.add("excedente");
                    } else {
                        texto.classList.remove("excedente");
                    }
                }, 10)
            }

        },

        async link() {
            if (this.seleccion != 'por kilo') {
                location.href = "#menu";
            } else {
                location.href = "#menu__busqueda"
            }
        },

        titulo: async function () {
            let array = await this.getAllInfoCtg("category");
        },

        filtrado() {
            let arr = this.dataprod
            let cat = this.datacat

            let narr = [];

            cat.forEach(element => {
                narr.push(element.name)
            });

            let ordenado = arr.sort((a, b) => {
                let indexA = narr.indexOf(a.category_name)
                let indexB = narr.indexOf(b.category_name)

                return indexA - indexB
            })

            return ordenado
        },

        //Hace que funcionen las flechas tanto en celular como en pc de los carruseles, además, llama la funcion contador
        scrolling(lado, clases) {
            const barra = document.getElementsByClassName(clases);
            const indexCat = this.datacat.findIndex(objeto => objeto.name === this.seleccion)

            if (lado === "derecha") {
                if (clases === "navegador") {
                    barra[0].scrollLeft += barra[0].offsetWidth;


                } else {
                    barra[indexCat].scrollLeft += 0.6 * barra[indexCat].offsetWidth
                    this.contador(indexCat)
                }

            } else {
                if (clases === "navegador") {
                    barra[0].scrollLeft -= barra[0].offsetWidth;
                } else {
                    barra[indexCat].scrollLeft -= 0.6 * barra[indexCat].offsetWidth
                    this.contador(indexCat)
                }
            }
        },

        control(lado) {
            const elemento = document.getElementById('control__buscador')
            const indexCat = this.datacat.findIndex(objeto => objeto.name === this.seleccion)
            if (lado === "derecha") {
                elemento.scrollLeft += elemento.offsetWidth
                this.contador(indexCat)


            } else {
                elemento.scrollLeft -= elemento.offsetWidth
                this.contador(indexCat)
            }
        },

        handleScroll() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.deslizMenu();
            }, 200);
        },

        deslizMenu() {
            const barra = document.getElementsByClassName("navegador");
            if (this.dataprod.length > 0) {
                setTimeout(() => {
                    let valor = Math.round(1 * barra[0].scrollLeft / barra[0].offsetWidth)
                    this.desliz(valor)
                }, 300);
            }
        },

        //Actualiza el contador segun la posición del scroll del producto individual en celular
        contador(indice) {
            const carrusel = document.getElementsByClassName("productos");

            let numero = Math.ceil(0.9 * carrusel[indice].scrollLeft / carrusel[indice].offsetWidth);
            this.counter = numero + 1;
        },

        //Calcula la cantidad de productos de la misma categoría en celular
        divisor(categoria) {
            const filteredData = this.dataprod.filter(objeto => objeto.category_name === categoria);
            this.denominador = filteredData.length;
        },

        //Hace que funcionen los botones del navegador de categorías
        desliz(index) {
            this.seleccion = this.datacat[index].name
            this.nombre(this.seleccion)
            if (this.seleccion != 'por kilo') {

                if (this.dataprod.length > 0) {
                    let itemOpacidad = document.querySelectorAll(".opacidad");
                    itemOpacidad.forEach(element => {
                        element.style.opacity = "0"
                    })

                    setTimeout(() => {
                        const carrusel = document.getElementById("cont__prod");
                        const productos = document.querySelectorAll(".productos");

                        setTimeout(() => {
                            itemOpacidad.forEach(element => {
                                element.style.opacity = "1"
                            });

                            AOS.init({
                                once: true
                            })

                            if (window.matchMedia("(min-width: 768px)").matches) {
                                carrusel.style.maxHeight = `${this.calcularFilas * 17.2 + 15.1}vw`
                            } else {
                                carrusel.style.maxHeight = `${this.calcularFilas * 65.625}vw`
                            }
                        }, 1000);
                        setTimeout(() => {
                            productos.forEach(producto => {
                                producto.scrollTo({ left: 0 });
                            });
                        }, 100);
                        setTimeout(() => {
                            carrusel.scrollTo({ left: index * 1.2 * carrusel.offsetWidth });
                            this.divisor(this.seleccion)
                        }, 100);

                        setTimeout(() => {
                            this.link();
                        }, 100);
                    }, 100);
                }

            } else {
                const elemento = document.getElementById('control__buscador')
                elemento.scrollLeft = 0;
                AOS.init({
                    once: true
                })
                setTimeout(() => {
                    setTimeout(() => {
                        this.link();
                    }, 500);
                }, 1000);

            }
        },
        saveLS: async function () {
            let payload3 = {
                mdc: 'none',
            }
            await this.setAddedCrt2(payload3)
        }
    },
}
</script>

<style scoped>
h1,
h2,
h3,
p {
    margin: 0;
}

.none {
    display: none;
}

.producto-individual {
    text-align: left !important;
}

.container {
    display: flex;
    flex-direction: column;
    background-color: #FFF9EA;
}

.container>div {
    position: relative;
}

.contenedor,
.productos {
    display: flex;
}

.productos,
.contenedor__productos {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.contenedor__productos::-webkit-scrollbar,
.productos::-webkit-scrollbar {
    display: none;
}

.item {
    border: 0.104vw solid #FF3723;
}

.titulo {
    text-align: center;
    font-family: 'Piknic-Regular';
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #FFB901;

    position: absolute;
    left: 50%;
    transform: translate(-49.3%, 0);
}

.superior {
    display: flex;
    border-bottom: 0.104vw solid #FF3723;
}

.superior p {
    font-family: 'Kinetica-Bold';
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #FF3723;
}

.inferior>h3 {
    font-family: 'Kinetica-Bold';
    font-style: normal;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #FF3723;
}

.inferior>div {
    display: flex;
}

.inferior>div a {
    font-family: 'Kinetica-Bold';
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #FF3723;

    border: 0.104vw solid #FF3723;

    display: flex;
}

.controles {
    display: flex;
}

.navegador>div>h2 {
    font-family: 'Piknic-Regular';
    font-style: normal;
    font-weight: 400;

    text-transform: uppercase;
    color: #FFB901;
}

.navegador>div>h3 {
    font-family: 'Kinetica-Bold';
    font-style: normal;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #194C06;
}

.navegador>div>h3::before {
    content: "*";
    font-family: 'Catou';
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #FF3723;

    position: relative;
}

.por__kilo h1 {
    color: #FFB901;
    font-family: 'Piknic-Regular';
    font-style: normal;
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;
    visibility: hidden;
}

.contenedor__buscador {
    display: flex;
    flex-wrap: wrap;
}

.arriba {
    display: flex;
    justify-content: space-between;
}

.arriba p {
    color: #FF3723;
    font-family: Kinetica-Bold;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
}

.abajo p {
    color: #FF3723;
    font-family: Kinetica-Bold;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
}

.abajo a {
    color: #FF3723;
    font-family: Kinetica-Bold;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
    display: block;
    position: absolute;
    text-align: center;
}

.navegacion__buscador {
    display: flex;
}

.buscador__categorias {
    display: flex;
}

.buscador__categorias h2 {
    color: #FFB901;
    font-family: Piknic-Regular;
    font-style: normal;
    font-weight: 400;
    text-transform: uppercase;
    position: absolute;
}

.buscador__categorias h3 {
    color: #194C06;
    font-family: Kinetica-Bold;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
    z-index: 2;
}

.categorias__texto h3::before {
    content: "*";
    color: #FF3723;
    font-family: Catou;
    font-style: normal;
    font-weight: 400;
    text-transform: uppercase;
    position: relative;
}

.no-coincidencias {
    position: relative;
    margin: 0 auto;
}

.productos__zanahoria {
    position: absolute;
    width: 100%;
}

.productos__zanahoria>div {
    position: relative;
    width: 100%;
}

.no-coincidencias>div>picture,
.productos__zanahoria>picture {
    display: grid;
}

.no-coincidencias>div>picture>img,
.productos__zanahoria>picture>img {
    height: auto;
}

.no-coincidencias h2 {
    color: #194C06;
    font-family: Kinetica-Bold;
    font-style: normal;
    font-weight: 700;
    text-transform: uppercase;
    position: relative;
}

.productos__zanahoria picture:nth-of-type(2) img {
    opacity: 0;
    animation: blink-1 2s linear infinite;
}

.productos__zanahoria picture:nth-of-type(3) img {
    opacity: 0;
    animation: blink-2 2s linear infinite;
}

.no-coincidencias>.animado>picture:nth-of-type(2)>img {
    opacity: 0;
    animation: blink-1 2s linear infinite;
}

.no-coincidencias>.animado>picture:nth-of-type(3)>img {
    opacity: 0;
    animation: blink-2 2s linear infinite;
}

@keyframes blink-1 {
    0% {
        opacity: 0;
    }

    32.33% {
        opacity: 0;
    }

    33.33% {
        opacity: 1;
    }

    100% {
        opacity: 1;
    }
}

@keyframes blink-2 {
    0% {
        opacity: 0;
    }

    65.66% {
        opacity: 0;
    }

    66.66% {
        opacity: 1;
    }

    100% {
        opacity: 1;
    }
}

/* Cel */
@media (max-width: 768px) {

    .container>div:first-of-type {
        min-height: 140vw;
    }

    .animado {
        width: 100vw;
        height: 73.00966183574879VW;
    }

    .no-coincidencias>div:not(.animado)>picture>img {
        width: 33.33333333333333VW;
        position: absolute;
        left: 56%;
        top: 33vw;
        transform: translateX(-60%)
    }

    .animado img {
        width: 33.33333333333333VW;
        position: absolute;
        left: 50vw;
        transform: translateX(-76%);
        top: 33vw;
    }

    .productos__zanahoria picture img {
        width: 33.33333333333333VW;
        position: absolute;
        left: 50%;
        transform: translateX(-60%)
    }

    .producto-individual {
        margin-left: 4.4vw;
    }

    .only-pc {
        display: none;
    }

    .slidecon {
        margin-top: 48.205128205128204VW;
    }

    .inferior>div>div,
    .superior>p:last-of-type {
        display: none;
    }

    .titulo {
        font-size: 28.205128205128204VW;
        line-height: 29.48717948717949VW;
        top: 17.48717948717949VW;
    }

    .productos {
        display: grid;
        grid-template-columns: repeat(2, 45.12820512820513VW);
        scroll-snap-align: start;
        row-gap: 2.051282051282051VW;
    }

    #cont__prod {
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        overflow: hidden;
        margin: 0 4.4vw 6vw;
    }

    #flex {
        display: flex;
        align-items: start;
        column-gap: 2.471795VW;
    }

    .excedente {
        font-size: 16.205128VW !important;
        margin-top: 5vw;
    }

    .item {
        display: grid;
        position: relative;
        height: 63.33333333333333VW;
    }

    .item>img {
        width: 37.104106280193236VW;
        height: 37.104106280193236VW;
        margin: 2.91025641025641VW auto 0;
    }

    .inferior>div {
        position: absolute;
        z-index: 2;
        top: 5.128205128205128VW;
        left: 5.384615384615385VW;
    }

    .inferior>div img {
        width: 12.051282051282051VW;
        height: 12.051282051282051VW;
    }

    .superior {
        margin: 0 2.8705128205128205VW 0;
        padding-bottom: 2.9vw;
        min-height: 7.7vw;
    }

    .superior p {
        font-size: 1.664103VW;
        line-height: normal;
        margin: 0 0 0 0.9vw;
    }

    .inferior {
        margin-top: -3vw;
    }

    .inferior h3 {
        font-size: 2.264103VW;
        line-height: normal;
        margin-top: 5vw;
    }

    .number {

        display: none;

        text-align: center;
        margin: 3.076923076923077VW 0 0 0;

        font-family: 'Kinetica-Bold';
        font-style: normal;
        font-weight: 700;
        font-size: 4.102564102564102VW;
        line-height: 7.435897435897436VW;
        text-transform: uppercase;
        color: #FF3723;
    }

    .controles {
        margin: 0 auto 12.82051282051282VW;
        align-items: center;
    }

    .flecha {
        margin: 2vw 3vw 0;
        width: 2.7948717948717947VW;
        height: 8.615384615384616VW;
    }

    .flecha:nth-of-type(1) {
        transform: rotate(180deg);
    }

    .navegador {
        display: grid;
        width: 78vw;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-behavior: smooth;
        -ms-overflow-style: none;
        scrollbar-width: none;
        scroll-snap-type: x mandatory;
        grid-auto-flow: column;
        column-gap: 23vw;
    }

    .navegador::-webkit-scrollbar {
        display: none;
    }

    .navegador>div {
        scroll-snap-align: center;
        justify-content: center;
        display: flex;
    }

    .navegador>div:first-of-type {
        margin-left: 28vw;
    }

    .navegador>div:last-of-type {
        margin-right: 28vw;
    }

    .navegador>div h2 {
        display: none;
    }

    .navegador>div>h3 {
        font-size: 4.653846VW;
        line-height: 11.23076923076923VW;
    }

    .navegador>div>h3::before {
        font-size: 10.256410256410255VW;
        line-height: 10.256410256410255VW;
        margin: 0 2.8307692307692305VW 0 0;
        top: 3.4vw;
    }

    .por__kilo h1 {
        font-size: 28.205128205128204VW;
        line-height: normal;
    }

    .contenedor__buscador {
        row-gap: 5.128205128205128VW;
        margin: 0vw 12.692307692307692VW 0vw;
    }

    .borde {
        display: grid;
        border: 0.5128205128205128VW solid #FF3723;
        padding: 5.641025641025641VW 5.256410256410256VW 7.948717948717948VW;
        max-height: 124.61538461538461VW;
        position: relative;
    }

    .borde .borde__imagen {
        width: 64.1025641025641VW;
        height: 64.1025641025641VW;
    }

    .arriba {
        width: 64.1025641025641VW;
        border-bottom: 0.5128205128205128VW solid #FF3723;
        padding-bottom: 4.358974358974359VW;
        margin-top: 2.8205128205128207VW;
    }

    .arriba p {
        font-size: 3.076923076923077VW;
        letter-spacing: 0.1846153846153846VW;
    }

    .abajo {
        margin: 2.8205128205128207VW 0 26.153846153846157VW;
        width: 64.1025641025641VW;
    }

    .abajo p {
        font-size: 3.902564VW;
        line-height: normal;
        letter-spacing: 0.24615384615384617VW;
    }

    .abajo a {
        padding: 2.51282051282vw 6.41025641025641VW;
        border: 0.5128205128205128VW solid #FF3723;
        border-radius: 15.384615384615385VW;
        font-size: 3.076923076923077VW;
        line-height: normal;
        letter-spacing: 0.46153846153846156VW;
        bottom: 7.948717948717948VW;
        left: 50%;
        transform: translateX(-50%);
        width: 44.3vw;
    }

    .sold__out {
        width: 16.666666666666664VW;
        aspect-ratio: 1;
        position: absolute;
        top: 11.025641025641026VW;
        left: 10.76923076923077VW;
    }

    .navegacion__buscador {
        margin: 21.794871794871796VW auto 12.82051282051282VW;
        align-items: center;
    }

    .buscador__categorias {
        display: grid;
        width: 75vw;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-behavior: smooth;
        -ms-overflow-style: none;
        scrollbar-width: none;
        scroll-snap-type: x mandatory;
        grid-auto-flow: column;
        column-gap: 23vw;
    }

    .buscador__categorias::-webkit-scrollbar {
        display: none;
    }

    .categorias__texto {
        scroll-snap-align: center;
        justify-content: center;
        display: flex;
    }

    .categorias__texto:first-of-type {
        margin-left: 28vw;
    }

    .categorias__texto:last-of-type {
        margin-right: 28vw;
    }

    .categorias__texto h2 {
        display: none;
    }

    .buscador__categorias h3 {
        font-size: 4.153846VW;
        line-height: normal;
        letter-spacing: 0.3692307692307692VW;
    }

    .categorias__texto h3::before {
        font-size: 7.853846VW;
        line-height: normal;
        letter-spacing: 0.3692307692307692VW;
        margin-right: 2.8307692307692305VW;
        top: 2.5vw;
    }

    .no-coincidencias {
        left: -1.7vw;
    }

    .no-coincidencias h2 {
        font-size: 5.153846VW;
        line-height: normal;
        letter-spacing: 0.5vw;
        text-align: center;
    }
}

/* PC */
@media (min-width: 768px) {

    .container>div:not(:last-of-type) {
        top: 7vw;
        margin-bottom: 6.3125VW;
    }

    .no-coincidencias>div>picture>img {
        position: absolute;
        width: 8.333333333333332VW;
        left: 50%;
        top: -15vw;
        transform: translateX(-50%)
    }

    .productos__zanahoria>div {
        height: 15.937499999999998VW;
    }

    .productos__zanahoria picture img {
        width: 8.333333333333332VW;
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translate(-50%, 50%)
    }

    .only-mov {
        display: none;
    }

    .por__kilo h1 {
        font-size: 23.4375VW;
        line-height: 61%;
        letter-spacing: 1.40625VW;
        transform: translateY(4vw);
        margin-top: -3vw;
    }

    .contenedor__buscador {
        gap: 1.054167VW;
        margin: 0vw 6.68125VW 0vw;
    }

    .borde {
        display: flex;
        column-gap: 4.114583333333333VW;
        border: 0.10416666666666667VW solid #FF3723;
        padding: 1.3020833333333335VW 1.7187500000000002VW 1.5104166666666667VW 1.3541666666666667VW;
        max-height: 13.021vw;
        position: relative;
    }

    .borde .borde__imagen {
        width: 13.020833333333334VW;
        height: 13.020833333333334VW;
    }

    .arriba {
        width: 20.833333333333336VW;
        border-bottom: 0.15625VW solid #FF3723;
        padding-bottom: 1.1458333333333333VW;
    }

    .arriba p {
        font-size: 0.7291666666666666VW;
        letter-spacing: 0.075VW;
    }

    .arriba p:first-of-type {
        max-width: 12.1vw;
    }

    .abajo {
        margin-top: 0.8333333333333334VW;
        width: 20.833333333333336VW;
    }

    .abajo p {
        font-size: 1.25VW;
        line-height: normal;
        letter-spacing: 0.075VW;
    }

    .abajo a {
        padding: 0.6770833333333334VW 1.3020833333333335VW 0.78125VW;
        border: 0.10416666666666667VW solid #FF3723;
        border-radius: 3.125VW;
        font-size: 0.625VW;
        line-height: normal;
        letter-spacing: 0.09375000000000001VW;
        width: 9vw;
        bottom: 2.864583333333333VW;
        right: 1.7187500000000002VW;
        transition: background-color 0.3s linear, color 0.3s linear;
    }

    .abajo a:hover {
        background-color: #FF3723;
        color: #FFF9EA;
        transition: background-color 0.3s linear, color 0.3s linear;
    }

    .sold__out {
        width: 5.677083333333333VW;
        aspect-ratio: 1;
        position: absolute;
        bottom: 1.0416666666666665VW;
        right: 17.083333333333332VW;
    }

    .navegacion__buscador {
        justify-content: center;
    }

    .buscador__categorias {
        margin: 5.3125VW 0 6.875000000000001VW;
        column-gap: 3.802083333333333VW;
    }

    .buscador__categorias h2 {
        font-size: 4.6875VW;
        line-height: normal;
        top: 4vw;
        transform: translateX(-5.4%);
        opacity: 0;
        transition: opacity 0.3s linear;
    }

    .buscador__categorias h3 {
        font-size: 1.25VW;
        line-height: normal;
        letter-spacing: 0.075VW;
    }

    .categorias__texto {
        cursor: pointer;
    }

    .categorias__texto h3::before {
        font-size: 2.083333333333333VW;
        line-height: normal;
        letter-spacing: 0.125VW;
        margin-right: 0.5vw;
        top: 0.4vw;
    }

    .categorias__texto:hover h2 {
        opacity: 1;
        transition: opacity 0.3s linear;
    }

    .no-coincidencias h2 {
        font-size: 1.95VW;
        line-height: normal;
        letter-spacing: 0.075VW;
        margin-top: 4vw;
    }

    .titulo {
        font-size: 23.4375VW;
        line-height: 91%;
        top: 1.875VW;
        height: 21.328125VW;
    }

    .excedente {
        font-size: 16.4375VW;
        margin-top: 3.3vw;
    }

    .contenedor__productos {
        width: 84vw;
        overflow-x: auto;
        margin-left: 50%;
        transform: translate(-50%, 0);
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        overflow-y: hidden;
    }

    #cont__prod {
        min-height: 32.3vw;
    }

    .flex {
        display: inline-flex;
        column-gap: 1.7vw;
        align-items: baseline;
    }

    .productos {
        width: 83.9375VW;
        margin: 16.079167VW auto 0;
        overflow: hidden;
        position: relative;
        z-index: 2;
        gap: 1.054167VW;
        flex-wrap: wrap;
        scroll-snap-align: center;
    }

    .item {
        display: flex;
        width: 41.041666666666664VW;
        height: 15.833333333333332VW;
    }

    .item>img {
        width: 13.020833333333334VW;
        height: 13.020833333333334VW;
        margin: 1.3020833333333335VW 3.90625VW 1.5104166666666667VW 1.3541666666666667VW;
    }

    .superior {
        width: 20.833333333333336VW;
        min-height: 4.75625vw;
    }

    .superior p {
        font-size: 0.7291666666666666VW;
        line-height: 1.3541666666666667VW;
    }

    .superior>p:first-of-type {
        width: 14.864583VW;
        min-height: 2.7083333333333335VW;
        margin: 1.3020833333333335VW 5.729167VW 0 0;
    }

    .superior>p:last-of-type {
        margin: 1.3020833333333335VW 0 0 0;
    }

    .inferior {
        margin: 0.8333333333333334VW 0 0 0;
    }

    .inferior>h3 {
        font-size: 1.25VW;
        line-height: 2.2916666666666665VW;
        /*margin: 0 3.6vw 0 0;*/
        margin: 0 0.6vw 0 0;
    }

    .inferior>div {
        margin: 0.8333333333333334VW 0 0 0;
    }

    .inferior>div>img {
        width: 5.677083333333333VW;
        height: 5.677083333333333VW;
        margin: 0 3.854166666666667VW 0 0;
    }

    .inferior>div>div {
        margin: 1.25VW 0 0 0;
        height: 2.604166666666667VW;
    }

    .inferior>div a {
        font-size: 0.625VW;
        line-height: 1.1458333333333333VW;
        padding: 0.6770833333333334VW 1.3020833333333335VW 0.78125VW;
        transition: 0.6s;
        border-radius: 5.208333333333334VW;
    }

    .inferior>div a:hover {
        background-color: #FF3723;
        color: #FFF9EA;
        transition: 0.6s;
    }

    .number {
        display: none;
    }

    .controles {
        margin: 0 auto;
        height: 14.583333333333334VW;
    }

    .navegador {
        display: flex;
        margin: 5.3125VW auto 6.875000000000001VW;

    }

    .navegador>div {
        margin: 0 3.802083333333333VW 0 0;
    }

    .navegador>div:last-of-type>h3 {
        margin: 0;
    }

    .navegador>div>h3::before {
        font-size: 2.083333333333333VW;
        line-height: 2.083333333333333VW;
        margin: 0 0.5208333333333333VW 0 0;
        top: 0.65vw;
    }

    .navegador>div {
        position: relative;
        cursor: pointer;
    }

    .navegador>div>h2 {
        position: absolute;
        top: 50%;
        transform: translate(-4.3%, -50%);
        z-index: 1;
        font-size: 4.6875VW;
        line-height: 4.895833333333333VW;
        opacity: 0;
        transition: opacity 0.3s linear;
    }

    .navegador div:hover h2 {
        opacity: 1;
        transition: opacity 0.5s linear;
    }

    .navegador>div>h3 {
        position: relative;
        z-index: 2;

        font-size: 1.25VW;
        line-height: 2.2916666666666665VW;
    }

    .flecha,
    .grande {
        display: none;
    }
}
</style>